import { ColumnVisibilitySettings } from '@contracts/common/ColumnVisibilitySettings';
import { ColumnVisibilityType } from '@contracts/common/ColumnVisibilityType';
import {
  defaultColumnVisibilityOptions,
  defaultColumnVisibilityParams,
} from '@contracts/common/params/ColumnVisibilityParams';

export const localizationListColumns = [
  'localizations.key',
  'localizations.ka',
  'localizations.ge',
  'localizations.ru',
  'localizations.en',
  'localizations.zh',
  'localizations.da',
  'localizations.fa',
  'localizations.ua',
  'localizations.tr',
  'localizations.de',
  'localizations.hy',
  'localizations.sv',
  'localizations.ar',
  'localizations.es',
  'localizations.fr',
  'localizations.ro',
  'localizations.el',
  'localizations.hi',
  'localizations.pt',
  'localizations.br',
  'localizations.sw',
  'localizations.th',
  'localizations.id',
  'localizations.vi',
  'localizations.ko',
  'localizations.hr',
  'localizations.is',
  'localizations.it',
  'localizations.ja',
  'localizations.lt',
  'localizations.hu',
  'localizations.pl',
  'localizations.sl',
  'localizations.nl',
  'localizations.et',
  'localizations.fi',
  'localizations.no',
  'localizations.sk',
  'localizations.zs',
  'localizations.sr',
  'localizations.bg',
] as const;

export type LocalizationListColumns = (typeof localizationListColumns)[number];

export type LocalizationListFilter = {
  'localizations.key': string | undefined;
  'localizations.ka': string | undefined;
  'localizations.ge': string | undefined;
  'localizations.en': string | undefined;
  'localizations.ru': string | undefined;
  'localizations.zh': string | undefined;
  'localizations.da': string | undefined;
  'localizations.fa': string | undefined;
  'localizations.ua': string | undefined;
  'localizations.tr': string | undefined;
  'localizations.de': string | undefined;
  'localizations.hy': string | undefined;
  'localizations.sv': string | undefined;
  'localizations.ar': string | undefined;
  'localizations.es': string | undefined;
  'localizations.fr': string | undefined;
  'localizations.ro': string | undefined;
  'localizations.el': string | undefined;
  'localizations.hi': string | undefined;
  'localizations.pt': string | undefined;
  'localizations.br': string | undefined;
  'localizations.sw': string | undefined;
  'localizations.th': string | undefined;
  'localizations.id': string | undefined;
  'localizations.vi': string | undefined;
  'localizations.ko': string | undefined;
  'localizations.hr': string | undefined;
  'localizations.is': string | undefined;
  'localizations.it': string | undefined;
  'localizations.ja': string | undefined;
  'localizations.lt': string | undefined;
  'localizations.hu': string | undefined;
  'localizations.pl': string | undefined;
  'localizations.sl': string | undefined;
  'localizations.nl': string | undefined;
  'localizations.et': string | undefined;
  'localizations.fi': string | undefined;
  'localizations.no': string | undefined;
  'localizations.sk': string | undefined;
  'localizations.zs': string | undefined;
  'localizations.sr': string | undefined;
  'localizations.bg': string | undefined;
};

export const defaultLocalizationListFilter: LocalizationListFilter = {
  'localizations.key': undefined,
  'localizations.ka': undefined,
  'localizations.ge': undefined,
  'localizations.ru': undefined,
  'localizations.en': undefined,
  'localizations.zh': undefined,
  'localizations.da': undefined,
  'localizations.fa': undefined,
  'localizations.ua': undefined,
  'localizations.tr': undefined,
  'localizations.de': undefined,
  'localizations.hy': undefined,
  'localizations.sv': undefined,
  'localizations.ar': undefined,
  'localizations.es': undefined,
  'localizations.fr': undefined,
  'localizations.ro': undefined,
  'localizations.el': undefined,
  'localizations.hi': undefined,
  'localizations.pt': undefined,
  'localizations.br': undefined,
  'localizations.sw': undefined,
  'localizations.th': undefined,
  'localizations.id': undefined,
  'localizations.vi': undefined,
  'localizations.ko': undefined,
  'localizations.hr': undefined,
  'localizations.is': undefined,
  'localizations.it': undefined,
  'localizations.ja': undefined,
  'localizations.lt': undefined,
  'localizations.hu': undefined,
  'localizations.pl': undefined,
  'localizations.sl': undefined,
  'localizations.nl': undefined,
  'localizations.et': undefined,
  'localizations.fi': undefined,
  'localizations.no': undefined,
  'localizations.sk': undefined,
  'localizations.zs': undefined,
  'localizations.sr': undefined,
  'localizations.bg': undefined,
};

export const localizationListColumnVisibilitySettings = {
  'localizations.key': ColumnVisibilityType.Visible,
  'localizations.ka': ColumnVisibilityType.CanBeVisible,
  'localizations.ge': ColumnVisibilityType.CanBeVisible,
  'localizations.ru': ColumnVisibilityType.CanBeVisible,
  'localizations.en': ColumnVisibilityType.CanBeHidden,
  'localizations.zh': ColumnVisibilityType.CanBeVisible,
  'localizations.da': ColumnVisibilityType.CanBeVisible,
  'localizations.fa': ColumnVisibilityType.CanBeVisible,
  'localizations.ua': ColumnVisibilityType.CanBeVisible,
  'localizations.tr': ColumnVisibilityType.CanBeVisible,
  'localizations.de': ColumnVisibilityType.CanBeVisible,
  'localizations.hy': ColumnVisibilityType.CanBeVisible,
  'localizations.sv': ColumnVisibilityType.CanBeVisible,
  'localizations.ar': ColumnVisibilityType.CanBeVisible,
  'localizations.es': ColumnVisibilityType.CanBeVisible,
  'localizations.fr': ColumnVisibilityType.CanBeVisible,
  'localizations.ro': ColumnVisibilityType.CanBeVisible,
  'localizations.el': ColumnVisibilityType.CanBeVisible,
  'localizations.hi': ColumnVisibilityType.CanBeVisible,
  'localizations.pt': ColumnVisibilityType.CanBeVisible,
  'localizations.br': ColumnVisibilityType.CanBeVisible,
  'localizations.sw': ColumnVisibilityType.CanBeVisible,
  'localizations.th': ColumnVisibilityType.CanBeVisible,
  'localizations.id': ColumnVisibilityType.CanBeVisible,
  'localizations.vi': ColumnVisibilityType.CanBeVisible,
  'localizations.ko': ColumnVisibilityType.CanBeVisible,
  'localizations.hr': ColumnVisibilityType.CanBeVisible,
  'localizations.is': ColumnVisibilityType.CanBeVisible,
  'localizations.it': ColumnVisibilityType.CanBeVisible,
  'localizations.ja': ColumnVisibilityType.CanBeVisible,
  'localizations.lt': ColumnVisibilityType.CanBeVisible,
  'localizations.hu': ColumnVisibilityType.CanBeVisible,
  'localizations.pl': ColumnVisibilityType.CanBeVisible,
  'localizations.sl': ColumnVisibilityType.CanBeVisible,
  'localizations.nl': ColumnVisibilityType.CanBeVisible,
  'localizations.et': ColumnVisibilityType.CanBeVisible,
  'localizations.fi': ColumnVisibilityType.CanBeVisible,
  'localizations.no': ColumnVisibilityType.CanBeVisible,
  'localizations.sk': ColumnVisibilityType.CanBeVisible,
  'localizations.zs': ColumnVisibilityType.CanBeVisible,
  'localizations.sr': ColumnVisibilityType.CanBeVisible,
  'localizations.bg': ColumnVisibilityType.CanBeVisible,
} satisfies ColumnVisibilitySettings<LocalizationListColumns>;

export const defaultLocalizationListColumnVisibility = defaultColumnVisibilityParams(
  localizationListColumnVisibilitySettings
);

export const localizationListColumnVisibilityOptions = defaultColumnVisibilityOptions(
  localizationListColumns,
  localizationListColumnVisibilitySettings
);
